import { render, staticRenderFns } from "./filemodel.vue?vue&type=template&id=2144d880&scoped=true&"
import script from "./filemodel.vue?vue&type=script&lang=js&"
export * from "./filemodel.vue?vue&type=script&lang=js&"
import style0 from "./filemodel.vue?vue&type=style&index=0&id=2144d880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144d880",
  null
  
)

export default component.exports